__turbopack_context__.v({
  "blockquote": "v7TW7a_blockquote",
  "body": "v7TW7a_body",
  "callout": "v7TW7a_callout",
  "details": "v7TW7a_details",
  "figure": "v7TW7a_figure",
  "h1": "v7TW7a_h1",
  "h2": "v7TW7a_h2",
  "h3": "v7TW7a_h3",
  "hr": "v7TW7a_hr",
  "li": "v7TW7a_li",
  "metaLabel": "v7TW7a_metaLabel",
  "metaRow": "v7TW7a_metaRow",
  "orderedList": "v7TW7a_orderedList",
  "p": "v7TW7a_p",
  "styledImage": "v7TW7a_styledImage",
  "styledImageFramed": "v7TW7a_styledImageFramed",
  "summary": "v7TW7a_summary",
  "table": "v7TW7a_table",
  "tableWrapper": "v7TW7a_tableWrapper",
  "td": "v7TW7a_td",
  "th": "v7TW7a_th",
  "toc": "v7TW7a_toc",
  "tocItem": "v7TW7a_tocItem",
  "tocList": "v7TW7a_tocList",
  "tocSummary": "v7TW7a_tocSummary",
  "toggleBody": "v7TW7a_toggleBody",
  "toggleIcon": "v7TW7a_toggleIcon",
});
